export const opportunitiesRouteNames = {
  default:'opportunities-v2',
  list:'opportunities-list-v2',
  byId:'opportunities-by-id',
  import:'opportunities-imports',
  pipeline:'pipeline-opportunities-v2',
  BulkActions:'bulk-actions-opportunities',
  pipelineDetail:'pipeline-opportunities-detail',
  //TODO: inform the bulk actions team about the name change
  OpportunitiesBulkActions:'opportunities-bulk-actions'
}
